import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Login from '../components/Login.vue'
import ForgotPassword from '../components/ForgotPassword.vue'
import ResetPassword from '../components/ResetPassword.vue'
import MFA from '../components/MFA.vue'
import VerifyPhone from '../components/VerifyPhone.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Login
  },
  {
    path: '/forgotPassword',
    name: 'Forgot Password',
    component: ForgotPassword
  },
  {
    path: '/VerifyPhone',
    name: 'Verify Phone',
    component: VerifyPhone
  },
  {
    path: '/MFA',
    name: 'MFA',
    component: MFA,
    props: route => ({
      session: route.params.session,
      phoneNumber: route.params.phoneNumber,
      email: route.params.email
    })
  },
  {
    path: '/resetPassword',
    name: 'Reset Password',
    component: ResetPassword
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
